import React, { ChangeEventHandler, forwardRef } from 'react';
import './Checkbox.scss';

interface CheckboxProps {
  label?: string;
  value?: string;
  required?: boolean;
  id: string;
  name: string;
  onChange: ChangeEventHandler<HTMLInputElement>;
  onBlur?: ChangeEventHandler<HTMLInputElement>;
  checked?: boolean;
}

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  ({ label, value = label, id, name, onChange, onBlur, checked, required }, ref) => {
    return (
      <label>
        <input
          ref={ref}
          type='checkbox'
          onChange={onChange}
          onBlur={onBlur}
          className='c-checkbox-input'
          name={name}
          value={value}
          id={id}
          defaultChecked={checked}
        />
      </label>
    );
  }
);
